import { ImageFilterHdrOutlineIcon } from './ImageFilterHdrOutlineIcon';

/**
 * author: Jeff Anders
 * id 45B91FE5-E3A6-44A3-B89E-5AE492BE231A
 * name image-filter-hdr-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-filter-hdr-outline.svg
 * tags
 * - Photography 
 * - Nature 
 */
export const MountainOutlineIcon = ImageFilterHdrOutlineIcon;
export default MountainOutlineIcon